import { send } from 'server';

export const requestSchedule = ({
    region = '',
    version = '1.6',
    schedulePeriod = 0,
    pageNumber = 1,
    pageSize = 10,
    lobbyName = 'Bingo',
    casino = '',
    scheduleDay = parseInt(new Date().getDay() + 1)
}) => {
    const siteScheduleRequest = {
        ID: 81710,
        description: 'Bingo scheduled games request',
        responses: [81711, 81712, 34002],
        region,
        version,
        casino,
        lobbyName,
        schedulePeriod,
        scheduleDay,
        pageNumber,
        pageSize
    };

    const lobbyRequest = {
        ID: 81701,
        description: 'Bingo Lobby request',
        responses: [81702, 81703],
        uniqueJackpots: true,
        region,
        version,
        casino,
        lobbyName
    };

    return Promise.all([send(siteScheduleRequest), send(lobbyRequest)]);
};
